import { EvalsRecordEvalRequest, EvalsRecordEvalResponse } from '@/generated/swagger/evals';

export class EvalClient {
  async recordEval(req: EvalsRecordEvalRequest) {
    const response = await fetch(`/api/evals/record`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(req),
    });
    return response.json() as Promise<EvalsRecordEvalResponse>;
  }
}

export const evalClient = new EvalClient();
